import axios from 'axios';
import * as React from 'react';
import { requestUpdateApPlanAction } from '../asyncHelpers/actionPlanService';
import { RequestStatus } from '../sic-lib/enums/RequestStatus';
import { UpdateApPlanActionRequest } from '../sic-lib/types/ApPlanAction';
import { useAppDispatch } from '../store/hooks';
import { createToast } from '../store/notify';
import { createErrorToast } from '../utils/notifyHelpers';

/**
 * useAsyncModifyApPlanAction
 *
 * @description
 * React hook providing request state management and cancellation for the
 * requestUpdateApPlanAction HTTP request
 */
export default function useAsyncModifyApPlanAction() {
    const request_token = axios.CancelToken.source();
    const dispatch = useAppDispatch();

    React.useEffect(() => {
        return () => {
            request_token.cancel();
        };
    }, []);

    const [requestStatus, setRequestStatus] = React.useState<RequestStatus>(RequestStatus.none);

    const asyncModifyApPlanAction = async (
        planId: number,
        actionId: number,
        apAction: UpdateApPlanActionRequest,
    ): Promise<boolean | undefined> => {
        try {
            setRequestStatus(RequestStatus.none);

            await requestUpdateApPlanAction(planId, actionId, apAction, request_token.token);

            setRequestStatus(RequestStatus.success);

            return true;
        } catch (error: any) {
            if (!axios.isCancel(error)) {
                /* Notify user of failed http request */
                const toastData = createErrorToast('Error while creating Action Plan action');

                dispatch(createToast({ toastData }));

                /* Update state */
                setRequestStatus(RequestStatus.error);
            }
        }
    };

    return {
        requestStatus,
        asyncModifyApPlanAction,
    };
}
